/* import __COLOCATED_TEMPLATE__ from './select-method.hbs'; */
import TwoFactorEnrollSelectMethodComponent from '@square/ember-multipass-components/components/ember-multipass-components/two-factor/enroll/select-method';
export default class TwoFactorModalEnrollSelectMethodComponent extends TwoFactorEnrollSelectMethodComponent {
  constructor() {
    super(...arguments);
  }
}